<template>
    <div class="form-control"
         style="display: flex;align-items: center;padding-right: 0;height: auto;border-radius: 0;border-top: none;border-left: none;border-right: none;cursor: pointer;"
    >
        <label style="width: 100%;margin: 0;line-height: 1.2;cursor: pointer;">{{ labelData }}</label>
        <input
                type="text"
                class="form-control bg-white"
                :value="valueData"
                :name="nameData"
                ref="input"
                readonly
                :disabled="disabledData"
                :required="requiredData"
                :placeholder="placeholderData"
                style="height: 0;width: 0;padding: 0;margin: 0;border: none;"
        />
<!--        <md-drop-down-icon/>-->
        <span style="font-size: 0.63rem;color: initial;">&#9660;</span>
    </div>
</template>

<script>
    // import MdDropDownIcon from '../../core/icons/MdDropDownIcon'

    export default {
        name: "CustomLabelInput",
        // components: {
        //     MdDropDownIcon,
        // },
        props: {
            label: {
                type: String,
                default: "",
            },
            value: {
                type: [String, Number],
                default: "",
            },
            name: {
                type: String,
                default: "",
            },
            placeholder: {
                type: String,
                default: ""
            },
            readonly: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            inputDefaultString: {
                type: String,
                default: '未選択'
            },
        },
        data() {
            return {
                labelData: this.label,
                valueData: this.value,
                disabledData: this.disabled,
                requiredData: this.required,
                readonlyData: this.readonly,
                placeholderData: this.placeholder,
                nameData: this.name,
            }
        },
        watch: {
            labelData: {
                immediate: true,
                    handler (labelData) {
                    if (!this.labelData || this.labelData.length === 0) {
                        this.labelData = this.inputDefaultString;
                    }
                }
            }
        },
        created() {
            if (!this.labelData || this.labelData.length === 0) {
                this.labelData = this.inputDefaultString;
            }
        }
    }
</script>

<style scoped>

</style>
